module.exports = __webpack_public_path__ + "static/media/recharge-icon.c564d2de.jpeg";